import { Container } from 'hypo-container';
import { HttpTransport } from '@estee/elc-http-transport';
import { IAppConfig } from '@estee/elc-universal-utils';
import AccountDashboardController from '~exported/account-dashboard/AccountDashboardController';
import AccountOrdersController from '~exported/account-orders/AccountOrdersController';
import AccountSidebarController from '~exported/account-sidebar/AccountSidebarController';
import { AccountOverlay } from '~domain/entities/AccountOverlay';
import { Config } from '~domain/entities/Config';
import { AccountRepository } from '~repositories/AccountRepository';
import { AuthenticatedRepository } from '~repositories/AuthenticatedRepository';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { AccountServiceStartedUseCase } from '~use-cases/AccountServiceStartedUseCase';
import serviceNames from '~setup/AccountService';
import { AccountService } from './AccountService';
import { ServiceBusController } from './ServiceBusController';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.appConfig = configJSON;
};

async function serviceInitializer(appConfig: IAppConfig) {
    setConfig(appConfig);

    const requestedBuidConfigs = ['language'];
    const useCase = new AccountServiceStartedUseCase({
        appConfig,
        requestedBuidConfigs
    });

    await useCase.execute();
}

diContainer
    .register(serviceNames.config, (c) => new Config(c.config))
    .register(serviceNames.httpTransport, (c) => new HttpTransport())
    .register(serviceNames.serviceBusController, (c) => new ServiceBusController())
    .register(serviceNames.accountOverlay, (c) => new AccountOverlay())
    .register(serviceNames.authenticatedRepository, (c) => new AuthenticatedRepository())
    .register(serviceNames.accountDashboardViewController, (c) => new AccountDashboardController())
    .register(serviceNames.accountOrdersViewController, (c) => new AccountOrdersController())
    .register(serviceNames.accountRepository, (c) => new AccountRepository())
    .register(
        serviceNames.accountSidebarViewController,
        (c) =>
            new AccountSidebarController({
                accountOverlay: c.get(serviceNames.accountOverlay),
                accountRepository: c.get(serviceNames.accountRepository),
                authenticatedRepository: c.get(serviceNames.authenticatedRepository)
            })
    )
    .register(
        serviceNames.configRepository,
        (c) =>
            new ConfigRepository({
                entity: c.get(serviceNames.config)
            })
    )
    .register(serviceNames.accountService, () => new AccountService(serviceInitializer));
